import { render, staticRenderFns } from "./SynchronisationSettings.vue?vue&type=template&id=fc16e2bc&scoped=true"
import script from "./SynchronisationSettings.vue?vue&type=script&lang=js"
export * from "./SynchronisationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc16e2bc",
  null
  
)

export default component.exports